/**
 * Where an openFile `/open-file` response navigates the share-view chrome:
 *  - a `spaPath` (a `_`/`.`/folder the recipient owns NATIVELY → their own drive, SPA mode) WINS,
 *    guarded same-origin (`/`-but-not-`//`), mirroring the ppn.gg BFF;
 *  - else a `{sessionId}` → the share-view sub-session;
 *  - else `null` → no navigation (uniform, no oracle).
 *
 * Pure + exported so the decision is unit-tested without mounting the (heavy) chrome — the bug it
 * guards against is a `{spaPath}` response navigating to `/share-view/undefined`.
 */
export function openFileNavPath(
  body: { sessionId?: string; spaPath?: string } | null,
): string | null {
  if (body?.spaPath && body.spaPath.startsWith('/') && !body.spaPath.startsWith('//')) {
    return body.spaPath
  }
  if (body?.sessionId) {
    return `/share-view/${body.sessionId}`
  }
  return null
}
